import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { CommonService } from 'src/app/shared/common/common.service';
import { ContentService } from '../../services/content.service';
import { NgIf } from '@angular/common';
import { ToastMessageComponent } from '../../../../shared/components/toast-message/toast-message.component';
import { MenuNavTravelerComponent } from '../menu-nav-traveler/menu-nav-traveler.component';

@Component({
    selector: 'app-saved-dependents',
    templateUrl: './saved-dependents.component.html',
    styleUrls: ['./saved-dependents.component.scss'],
    imports: [NgIf, ToastMessageComponent, MenuNavTravelerComponent, RouterOutlet]
})
export class SavedDependentsComponent implements OnInit, OnDestroy {
  renderer: boolean = true;
  showToastMessage: boolean = true;
  sidebar!: boolean;
  descriptionData: string = '';
  content:any;
  private destroy$ = new Subject<void>();
  constructor(private _CommonService: CommonService, private router: Router,private contentService:ContentService) {
    this._CommonService.componentRendererTrigger.subscribe(($: boolean) => {
      this.renderer = $;
    })
  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    })
    this._CommonService.setData('camSidebar', false)

  
  this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
  ).subscribe((event: NavigationEnd) => {
    // Hide toast ONLY on '/personal-info', show everywhere else (including '/dependent-form')
    this.showToastMessage = !this.isPersonalInfoRoute(event.url);
  });
  this.showToastMessage = !this.isPersonalInfoRoute(this.router.url);
  
  this.sidebar = this._CommonService.getData('camSidebar');

    console.log(this.showToastMessage)
    console.log(this.sidebar)
  }

  private isPersonalInfoRoute(url: string): boolean {
    // Check if URL contains '/personal-info' (case-sensitive)
    return url.includes('/personal-info');
  }
  isNewDependent(){
    return this.router.url.includes('dependent-information-form');
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
  
}

